<span class="block bg-[--color-featured] text-white text-xs font-extrabold px-2 py-0.5 rounded-full">{{
  label()
}}</span>
